import { compose, withState, withProps, withHandlers } from 'recompose'
import { Map } from 'immutable'

import MultiSignaturePreview from './component'

/*
 * expected props:
 *
 * multiSignature -> Immutable.Map() - the response payload from the server
 * multiSignaturePreviewFetchPending -> boolean - whether the fetch for the multi signature is in flight
 * multiSignaturePreviewFetchFailed -> boolean - whether the last fetch failed
 * onRefetchClick -> function - the function to call when re-trying a multi signature fetch
 *
 * all the other props are internal to the component
 */
export default compose(
  withState('selectedSignatureIndex', 'setSelectedSignatureIndex', 0),
  withProps(props => {
    const noBannerSigId = props.multiSignature.get('noBannerSignatureId')
    const nonEmptySigIds = [...props.multiSignature.get('populatedSignatures', Map()).filter((sig, sigId) => sigId !== `${noBannerSigId}`).keys()]
    const currentlyViewingSignature = props.selectedSignatureIndex === nonEmptySigIds.length
      ? props.multiSignature.getIn(['populatedSignatures', `${noBannerSigId}`])
      : props.multiSignature.getIn(['populatedSignatures', `${nonEmptySigIds[props.selectedSignatureIndex]}`])

    return {
      viewingSignatureNumber: props.selectedSignatureIndex === nonEmptySigIds.length ? 'No Banner' : `${props.selectedSignatureIndex + 1} / ${nonEmptySigIds.length}`,
      doCycle: props.multiSignature.get('doCycle', false),
      numSignatures: nonEmptySigIds.length,
      currentlyViewingSignature,
      noBannerSigId,
    }
  }),
  withHandlers({
    onNextSignatureClick: props => () => {
      props.setSelectedSignatureIndex((props.selectedSignatureIndex + 1) % (!!props.noBannerSigId ? props.numSignatures + 1 : props.numSignatures))
    },
    onPreviousSignatureClick: props => () => {
      const next = props.selectedSignatureIndex - 1
      if (next === -1) {
        props.setSelectedSignatureIndex(!!props.noBannerSigId ? props.numSignatures : props.numSignatures - 1)
      } else {
        props.setSelectedSignatureIndex(next)
      }
    },
  }),
)(MultiSignaturePreview)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/MultiSignaturePreview/index.js